module.exports = __webpack_public_path__ + "static/media/College.b5c3bacf.png";